import type { ReactElement } from 'react';
import { avatarTone, initials } from './format';
import styles from './Avatar.module.css';

interface AvatarProps {
  /** Id do contato: define a cor, que não muda entre renderizações nem entre sessões. */
  contactId: string;
  name: string;
}

/** Círculo com as iniciais. Decorativo: o nome do contato já aparece em texto ao lado. */
export function Avatar({ contactId, name }: AvatarProps): ReactElement {
  const letters = initials(name);
  return (
    <span
      className={`${styles.avatar} ${styles[`tone${avatarTone(contactId)}`] ?? ''}`}
      aria-hidden="true"
    >
      {letters || (
        // Contato só com telefone (ou nome sem letras): um ícone de pessoa em vez de dígitos soltos.
        <svg className={styles.glyph} viewBox="0 0 24 24" focusable="false">
          <circle cx="12" cy="8.5" r="4" fill="currentColor" />
          <path d="M4 20c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5z" fill="currentColor" />
        </svg>
      )}
    </span>
  );
}
